import React from 'react';
import OpFooter from '../optimus/sections/OpFooter';

interface FooterProps {
  darkMode: boolean;
}

/**
 * Global footer — delegates to the Optimus design-system footer so every page
 * shares the same monochrome editorial footer (ASCII wave, link columns).
 * Wrapped in `.op-page` so its animations are exempt from the legacy motion
 * kill-switches even on pages that aren't fully Optimus yet.
 */
const Footer: React.FC<FooterProps> = ({ darkMode }) => (
  <div className="op-page">
    <OpFooter darkMode={darkMode} />
  </div>
);

export default Footer;
